import Page from "../../components/page/Page";
import {Box, Divider, List, Typography, useTheme} from "@mui/material";
import MarginRow from "../../components/page/MarginRow";
import React, {useEffect, useState} from "react";
import Drawer, {openDrawerWidth} from "../../components/mui/Drawer";
import {useResources} from "../../stores/ResourceProvider";
import NavListItem from "../../components/controls/NavListItem";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoutesConfig, {RoutesConfigHelpers} from "../../RoutesConfig";
import {useLocation, useNavigate} from "react-router-dom";
import ManageUsersView from "./ManageUsersView";
import Footer from "../../components/page/Footer";
import AssessmentIcon from '@mui/icons-material/Assessment';
import AdminReportsView from "./AdminReportsView";
import useIsMobile from "../../components/useIsMobile";

const AdminPage = () => {
  const [isNavDrawerOpen, setIsNavDrawerOpen] = useState<boolean>(true)
  const [view, setView] = useState<string | undefined>("legacy-users")
  const viewNames = ["users", "migrate", "reports"]

  const {userStore} = useResources()
  const isAdmin = userStore.isAdmin

  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useIsMobile()

  useEffect(() => {
    const viewName = RoutesConfigHelpers.getPathSegment(location.pathname, 2)
    if (viewName && viewNames.indexOf(viewName) >= 0) {
      setView(viewName)
    } else {
      navigate(`${RoutesConfig.admin.pathname}/users`)
    }
  }, [navigate])

  const onViewChange = (event: any, view: string) => {
    navigate(`${RoutesConfig.admin.pathname}/${view}`)
  }

  const renderDrawer = () => {
    const drawerLabel = isAdmin ? "Retirement Admin" : "Retirement Admin"

    return (
      <Drawer variant="permanent" open={isNavDrawerOpen}
              PaperProps={{
                sx: {
                  backgroundColor: theme.palette.background.default,
                  marginTop: "70px",
                  borderStyle:"none"
                }
              }}
      >
        <Divider />
        <Box sx={{display:"flex", mt:3.5, pl:2, pb:0, mb:0,}}>
          <Typography variant="h5" color="primary">{drawerLabel}</Typography>
        </Box>
        <List dense>
          <NavListItem id="users"
                       icon={<ManageAccountsIcon/>}
                       primary="Manage Users"
                       selected={view === "users"}
                       onClick={onViewChange}
                       drawerOpen={true}
          />
          <NavListItem id="reports"
                       icon={<AssessmentIcon/>}
                       primary="Reports"
                       selected={view === "reports"}
                       onClick={onViewChange}
                       drawerOpen={true}
          />
        </List>
      </Drawer>
    )
  }

  return (
    <Page title="Admin">
      <MarginRow>
        {!isMobile && renderDrawer()}
        <Box component="main" sx={{ flexGrow:1, width:"100%",ml:`${isMobile ? 0 : openDrawerWidth}px`}}>
          {view === "users" &&
            <ManageUsersView />
          }
          {/*{view === 'migrate' &&*/}
          {/*  <MigrateUsersView/>*/}
          {/*}*/}
          {view === 'reports' &&
            <AdminReportsView/>
          }
          <Footer />
        </Box>
      </MarginRow>
    </Page>
  )

}

export default AdminPage